var _rect, _g, _rect2, _g2, _rect3, _path, _g3, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 24,
    fill: "#2B2B2B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_45070)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -465,
    y: -399,
    width: 1440,
    height: 1162,
    rx: 20,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-465 -379C-465 -390.046 -456.046 -399 -445 -399H955C966.046 -399 975 -390.046 975 -379V995C975 1006.05 966.046 1015 955 1015H-445C-456.046 1015 -465 1006.05 -465 995V-379Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -195.5,
    y: -167.5,
    width: 1131,
    height: 883,
    rx: 20.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -195,
    y: -31,
    width: 1130,
    height: 68,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40.1513 -2.18182H-41.9957V8H-40.1513V-2.18182ZM-36.4338 3.52557C-36.4338 2.42188 -35.7676 1.78551 -34.818 1.78551C-33.8883 1.78551 -33.3315 2.39702 -33.3315 3.41619V8H-31.5318V3.13778C-31.5268 1.30824 -32.5708 0.264205 -34.1468 0.264205C-35.2903 0.264205 -36.0758 0.81108 -36.4238 1.66122H-36.5133V0.363636H-38.2335V8H-36.4338V3.52557ZM-25.889 0.363636H-27.3954V-1.46591H-29.1951V0.363636H-30.2789V1.75568H-29.1951V6.00142C-29.2051 7.43821 -28.161 8.14418 -26.8088 8.1044C-26.2967 8.08949 -25.9437 7.99006 -25.7498 7.92543L-26.0531 6.51847C-26.1525 6.54332 -26.3564 6.58807 -26.5801 6.58807C-27.0325 6.58807 -27.3954 6.42898 -27.3954 5.70312V1.75568H-25.889V0.363636ZM-24.3839 8H-22.5842V3.51065C-22.5842 2.54119 -21.8533 1.85511 -20.864 1.85511C-20.5607 1.85511 -20.1829 1.9098 -20.0288 1.95952V0.303977C-20.1928 0.274147 -20.4762 0.254261 -20.6751 0.254261C-21.5501 0.254261 -22.2809 0.75142 -22.5593 1.63636H-22.6388V0.363636H-24.3839V8ZM-15.8166 8.14915C-13.5794 8.14915 -12.1575 6.57315 -12.1575 4.21165C-12.1575 1.84517 -13.5794 0.264205 -15.8166 0.264205C-18.0538 0.264205 -19.4757 1.84517 -19.4757 4.21165C-19.4757 6.57315 -18.0538 8.14915 -15.8166 8.14915ZM-15.8066 6.70739C-17.0446 6.70739 -17.6511 5.60369 -17.6511 4.20668C-17.6511 2.80966 -17.0446 1.69105 -15.8066 1.69105C-14.5886 1.69105 -13.9821 2.80966 -13.9821 4.20668C-13.9821 5.60369 -14.5886 6.70739 -15.8066 6.70739ZM-9.52131 8.10938C-8.93466 8.10938 -8.43253 7.62216 -8.42756 7.01562C-8.43253 6.41903 -8.93466 5.93182 -9.52131 5.93182C-10.1278 5.93182 -10.62 6.41903 -10.6151 7.01562C-10.62 7.62216 -10.1278 8.10938 -9.52131 8.10938ZM0.401989 0.363636H-1.1044V-1.46591H-2.90412V0.363636H-3.98793V1.75568H-2.90412V6.00142C-2.91406 7.43821 -1.87003 8.14418 -0.517756 8.1044C-0.00568151 8.08949 0.347301 7.99006 0.541193 7.92543L0.237926 6.51847C0.138494 6.54332 -0.0653408 6.58807 -0.289062 6.58807C-0.741477 6.58807 -1.1044 6.42898 -1.1044 5.70312V1.75568H0.401989V0.363636ZM5.15607 8.14915C7.39329 8.14915 8.81516 6.57315 8.81516 4.21165C8.81516 1.84517 7.39329 0.264205 5.15607 0.264205C2.91886 0.264205 1.49698 1.84517 1.49698 4.21165C1.49698 6.57315 2.91886 8.14915 5.15607 8.14915ZM5.16602 6.70739C3.92809 6.70739 3.32156 5.60369 3.32156 4.20668C3.32156 2.80966 3.92809 1.69105 5.16602 1.69105C6.38406 1.69105 6.99059 2.80966 6.99059 4.20668C6.99059 5.60369 6.38406 6.70739 5.16602 6.70739ZM22.6101 1.25355C22.2969 -1.00852 20.5568 -2.32102 18.2997 -2.32102C15.6399 -2.32102 13.6364 -0.382103 13.6364 2.90909C13.6364 6.19531 15.6151 8.1392 18.2997 8.1392C20.7209 8.1392 22.3267 6.57315 22.6101 4.62926L20.7507 4.61932C20.517 5.8125 19.5426 6.48366 18.3246 6.48366C16.674 6.48366 15.4908 5.24574 15.4908 2.90909C15.4908 0.612216 16.6641 -0.665483 18.3295 -0.665483C19.5675 -0.665483 20.5369 0.0355111 20.7507 1.25355H22.6101ZM27.5506 8.14915C29.7878 8.14915 31.2097 6.57315 31.2097 4.21165C31.2097 1.84517 29.7878 0.264205 27.5506 0.264205C25.3134 0.264205 23.8915 1.84517 23.8915 4.21165C23.8915 6.57315 25.3134 8.14915 27.5506 8.14915ZM27.5605 6.70739C26.3226 6.70739 25.7161 5.60369 25.7161 4.20668C25.7161 2.80966 26.3226 1.69105 27.5605 1.69105C28.7786 1.69105 29.3851 2.80966 29.3851 4.20668C29.3851 5.60369 28.7786 6.70739 27.5605 6.70739ZM37.6044 4.78835C37.6044 5.9517 36.7741 6.52841 35.9787 6.52841C35.1136 6.52841 34.5369 5.9169 34.5369 4.94744V0.363636H32.7372V5.22585C32.7372 7.06037 33.7812 8.09943 35.2827 8.09943C36.4261 8.09943 37.2315 7.49787 37.5795 6.64276H37.6591V8H39.4041V0.363636H37.6044V4.78835ZM41.2548 8H43.0545V3.51065C43.0545 2.54119 43.7853 1.85511 44.7747 1.85511C45.0779 1.85511 45.4558 1.9098 45.6099 1.95952V0.303977C45.4458 0.274147 45.1625 0.254261 44.9636 0.254261C44.0886 0.254261 43.3578 0.75142 43.0794 1.63636H42.9998V0.363636H41.2548V8ZM52.8411 2.3821C52.5925 1.08949 51.5584 0.264205 49.7686 0.264205C47.9292 0.264205 46.6763 1.16903 46.6813 2.58097C46.6763 3.6946 47.3624 4.4304 48.829 4.73366L50.1316 5.0071C50.8326 5.16122 51.1607 5.4446 51.1607 5.87713C51.1607 6.39915 50.5939 6.7919 49.7388 6.7919C48.9135 6.7919 48.3766 6.43395 48.2225 5.74787L46.4675 5.9169C46.6912 7.31889 47.8695 8.14915 49.7438 8.14915C51.6529 8.14915 53.0002 7.1598 53.0051 5.71307C53.0002 4.62429 52.2992 3.9581 50.8574 3.64489L49.5549 3.36648C48.7793 3.19247 48.4711 2.92401 48.476 2.48153C48.4711 1.96449 49.0428 1.60653 49.7935 1.60653C50.6238 1.60653 51.0613 2.05895 51.2005 2.56108L52.8411 2.3821ZM57.8699 8.14915C59.6497 8.14915 60.8727 7.27912 61.1909 5.9517L59.5105 5.76278C59.2669 6.40909 58.6703 6.74716 57.8947 6.74716C56.7314 6.74716 55.9608 5.98153 55.9458 4.67401H61.2654V4.12216C61.2654 1.44247 59.6547 0.264205 57.7754 0.264205C55.5879 0.264205 54.161 1.87003 54.161 4.22656C54.161 6.62287 55.568 8.14915 57.8699 8.14915ZM55.9508 3.46094C56.0055 2.48651 56.7264 1.66619 57.8002 1.66619C58.8343 1.66619 59.5304 2.42188 59.5403 3.46094H55.9508ZM68.8235 2.3821C68.5749 1.08949 67.5408 0.264205 65.7511 0.264205C63.9116 0.264205 62.6587 1.16903 62.6637 2.58097C62.6587 3.6946 63.3448 4.4304 64.8114 4.73366L66.114 5.0071C66.815 5.16122 67.1431 5.4446 67.1431 5.87713C67.1431 6.39915 66.5763 6.7919 65.7212 6.7919C64.896 6.7919 64.359 6.43395 64.2049 5.74787L62.4499 5.9169C62.6737 7.31889 63.8519 8.14915 65.7262 8.14915C67.6353 8.14915 68.9826 7.1598 68.9876 5.71307C68.9826 4.62429 68.2816 3.9581 66.8398 3.64489L65.5373 3.36648C64.7617 3.19247 64.4535 2.92401 64.4585 2.48153C64.4535 1.96449 65.0252 1.60653 65.7759 1.60653C66.6062 1.60653 67.0437 2.05895 67.1829 2.56108L68.8235 2.3821Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -195.5,
    y: -167.5,
    width: 1131,
    height: 883,
    rx: 20.5,
    stroke: "#EFF0F6"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -465,
    y: -399,
    width: 1440,
    height: 1162,
    fill: "black",
    fillOpacity: 0.2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_49_45070)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -109,
    width: 581,
    height: 583,
    rx: 20,
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -18,
    width: 360,
    height: 60,
    rx: 10,
    fill: "black",
    fillOpacity: 0.04
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_49_45070",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H12V4C12 5.10457 12.8954 6 14 6H18V22C18 23.1046 17.1046 24 16 24H2C0.89543 24 0 23.1046 0 22V2Z",
    fill: "#47A7FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_49_45070)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 2C0 0.89543 0.895431 0 2 0H12V4C12 5.10457 12.8954 6 14 6H18V22C18 23.1046 17.1046 24 16 24H2C0.89543 24 0 23.1046 0 22V2Z",
    fill: "#29CF61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11C5.22386 11 5 11.2239 5 11.5V11.8333C5 12.1095 5.22386 12.3333 5.5 12.3333H7.16667C7.44281 12.3333 7.66667 12.1095 7.66667 11.8333V11.5C7.66667 11.2239 7.44281 11 7.16667 11H5.5Z",
    fill: "#29CF61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13.6667C5.22386 13.6667 5 13.8905 5 14.1667V14.5C5 14.7761 5.22386 15 5.5 15H7.16667C7.44281 15 7.66667 14.7761 7.66667 14.5V14.1667C7.66667 13.8905 7.44281 13.6667 7.16667 13.6667H5.5Z",
    fill: "#29CF61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16.8333C5 16.5572 5.22386 16.3333 5.5 16.3333H7.16667C7.44281 16.3333 7.66667 16.5572 7.66667 16.8333V17.1667C7.66667 17.4428 7.44281 17.6667 7.16667 17.6667H5.5C5.22386 17.6667 5 17.4428 5 17.1667V16.8333Z",
    fill: "#29CF61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83333 11C8.55719 11 8.33333 11.2239 8.33333 11.5V11.8333C8.33333 12.1095 8.55719 12.3333 8.83333 12.3333H12.5C12.7761 12.3333 13 12.1095 13 11.8333V11.5C13 11.2239 12.7761 11 12.5 11H8.83333Z",
    fill: "#29CF61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 14.1667C8.33333 13.8905 8.55719 13.6667 8.83333 13.6667H12.5C12.7761 13.6667 13 13.8905 13 14.1667V14.5C13 14.7761 12.7761 15 12.5 15H8.83333C8.55719 15 8.33333 14.7761 8.33333 14.5V14.1667Z",
    fill: "#29CF61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83333 16.3333C8.55719 16.3333 8.33333 16.5572 8.33333 16.8333V17.1667C8.33333 17.4428 8.55719 17.6667 8.83333 17.6667H12.5C12.7761 17.6667 13 17.4428 13 17.1667V16.8333C13 16.5572 12.7761 16.3333 12.5 16.3333H8.83333Z",
    fill: "#29CF61"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4V0L18 6H14C12.8954 6 12 5.10457 12 4Z",
    fill: "#29CF61"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_49_45070",
    x: -59,
    y: -131,
    width: 629,
    height: 631,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_49_45070"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_49_45070",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_45070"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -465,
    y: -399,
    width: 1440,
    height: 1162,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFilledIcon);
export default __webpack_public_path__ + "static/media/FileFilledIcon.5f566fdd0dcab885cb79553d781e8d14.svg";
export { ForwardRef as ReactComponent };